// Incoming-shipments API — endpoints injected into the single baseApi (ARCHITECTURE §7).
import { baseApi } from '@/lib/api/baseApi';
import { incomingShipmentsEndpoints } from './incomingShipments.queries';

export const incomingShipmentsApi = baseApi.injectEndpoints({
  endpoints: incomingShipmentsEndpoints,
});

export const {
  useGetIncomingShipmentsQuery,
  useGetShipmentFilterOptionsQuery,
  useCreateIncomingShipmentMutation,
  useGetShipmentFormQuery,
  useUpdateIncomingShipmentMutation,
  useDeleteIncomingShipmentMutation,
  useGetShipmentDetailQuery,
  useGetLinkedContractsForShipmentQuery,
  useGetLinkedDeclarationsForShipmentQuery,
  useUnlinkContractFromShipmentMutation,
} = incomingShipmentsApi;
